import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetRenters } from './getRenters';
export const DependencyInjectionRentersInfrastructure = () => {
    container.register("iGetRenters", { useClass: GetRenters });
};
export default DependencyInjectionRentersInfrastructure;
